import { useEffect, useState } from "react";
import {
	Box,
	Chip,
	Divider,
	IconButton,
	InputAdornment,
	ListItem,
	Pagination,
	Stack,
	TextField,
	Tooltip,
	Typography,
	useTheme,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { Clear, OpenInNew, Search } from "@mui/icons-material";
import api from "../../../../services/api";
import ModalDetails from "./modalDetails";
import useStyles from "./styles";

import dayjs from "dayjs";
import DatagridComponent from "../../../../components/datagridComponent";
const utc = require("dayjs/plugin/utc");
const timezone = require("dayjs/plugin/timezone");

dayjs.extend(utc);
dayjs.extend(timezone);

const timeZone = "America/Sao_Paulo";

//dayjs(cobranca?.invoice_date_due).format("DD-MM-YYYY") || "-",
export default function RegistroLogin(params) {
	const { searchItem, setSearchItem, filterData } = params;
	const theme = useTheme();
	const styles = useStyles(theme);
	const [rows, setRows] = useState([]);
	const [selectedRow, setSelectedRow] = useState({});
	const [initialLoad, setInitialLoad] = useState(true);
	const [openDetalhes, setOpenDetalhes] = useState(false);
	const [windowWidth, setWindowWidth] = useState(window.innerWidth);

	// Função para receber dados do banco
	async function handleGetLogs() {
		try {
			setInitialLoad(true);
			const response = await api.post("/administracao/logsLogin", {
				initialDate: filterData?.initialDate,
				finalDate: filterData?.finalDate,
			});

			setRows(response?.data);
		} catch (error) {
		} finally {
			setInitialLoad(false);
		}
	}

	useEffect(() => {
		// Ao carregar a página chama api para receber os logs
		handleGetLogs();

		// Define state com a largura da tela
		const handleResize = () => {
			setWindowWidth(window.innerWidth);
		};
		// Adiciona um listener ao evento de redimensionar a tela
		window.addEventListener("resize", handleResize);
		// O evento chama a função que define o valor do state
	}, [filterData]);

	// Filtra os dados a serem seguidos de acordo com a busca
	const filteredRows = rows?.filter((row, index) => {
		row.numero = index;
		const nome =
			row?.user?.nome?.toLowerCase() +
			" " +
			row?.user?.sobrenome?.toLowerCase();

		return (
			(row?.status === 1 && "sucesso".includes(searchItem?.toLowerCase())) ||
			(row?.status === 0 && "falha".includes(searchItem?.toLowerCase())) ||
			row?.table?.toLowerCase()?.includes(searchItem?.toLowerCase()) ||
			dayjs(row?.createAt)
				.format("DD/MM/YYYY HH:mm:ss")
				?.includes(searchItem?.toLowerCase()) ||
			nome?.includes(searchItem?.toLowerCase())
		);
	});

	//views a serem renderizados nos referentes renderCell
	const timeCellView = (params) => {
		return (
			<Box
				sx={{
					width: "100%",
					display: "flex",
					alignItems: "center",
					flexDirection: "row",
					gap: 1,
				}}
			>
				<Typography sx={styles.typographCellView}>
					{
						dayjs(params?.row?.createAt)
							.tz(timeZone)
							.format("DD/MM/YYYY HH:mm:ss")
							.split(" ")[0]
					}
				</Typography>
				<Typography sx={styles.typographCellView}>
					{
						dayjs(params?.row?.createAt)
							.tz(timeZone)
							.format("DD/MM/YYYY HH:mm:ss")
							.split(" ")[1]
					}
				</Typography>
			</Box>
		);
	};

	const userCellView = (params) => {
		return (
			<Box sx={styles.boxCellView}>
				<Typography sx={styles.typographCellView}>
					{params?.row?.user?.nome} {params?.row?.user?.sobrenome}
				</Typography>
			</Box>
		);
	};

	const tableCellView = (params) => {
		return (
			<Box sx={styles.boxCellView}>
				<Typography sx={styles.typographCellView}>
					{params?.row?.table}
				</Typography>
			</Box>
		);
	};

	const actionCellView = (params) => {
		return (
			<Chip
				label={params?.row?.status === 0 ? "Falha" : "Sucesso"}
				sx={{
					bgcolor:
						params?.row?.status === 0
							? "chip.main.pending"
							: "chip.main.completed",
					width: "100px",
					height: "18px",
					color: theme.palette.white.main,
					fontWeight: 600,
				}}
				size="small"
			/>
		);
	};

	const detailCellView = (params) => {
		return (
			<Tooltip title="Detalhes da ação">
				<IconButton
					onClick={(event) => {
						event.preventDefault();
						setSelectedRow(params.row);
						setOpenDetalhes(!openDetalhes);
					}}
					id="basic-button"
					sx={{
						paddingY: 0,
						alignItems: "center",
						justifyContent: "center",
					}}
				>
					<OpenInNew mode="view" params={params} />
				</IconButton>
			</Tooltip>
		);
	};

	// Definição de colunas
	const columns = [
		{
			editable: false,
			field: "id",
			headerName: "ID",
			hide: true,
		},
		{
			field: "createAt",
			headerName: "Hora",
			flex: 0.8,
			type: "dataTime",
			renderCell: timeCellView,
		},
		{
			field: "user",
			headerName: "Usuário",
			flex: 1,
			valueGetter: (params) => {
				return params?.nome;
			},
			renderCell: userCellView,
		},
		{
			field: "table",
			headerName: "Recurso",
			flex: 0.8,
			renderCell: tableCellView,
		},
		{
			field: "action",
			headerName: "Tipo",
			flex: 0.6,
			valueGetter: (params) => {
				return params?.row?.status === 1 ? "Sucesso" : "Falha";
			},
			renderCell: actionCellView,
		},
		{
			field: "detail",
			headerName: "Detalhes",
			width: 90,
			renderCell: detailCellView,
			sortable: false,
		},
	];

	// Variáveis para o carregamento mobile
	const PER_PAGE = 10;
	const count = Math.ceil(filteredRows.length / PER_PAGE);
	const _DATA = usePagination(filteredRows, PER_PAGE);
	const [page, setPage] = useState(1);

	// Pagination para o mobile
	function usePagination(data, itemsPerPage) {
		const [currentPage, setCurrentPage] = useState(1);
		const maxPage = Math.ceil(data.length / itemsPerPage);

		function currentData() {
			const begin = (currentPage - 1) * itemsPerPage;
			const end = begin + itemsPerPage;
			return data.slice(begin, end);
		}

		function next() {
			setCurrentPage((currentPage) => Math.min(currentPage + 1, maxPage));
		}

		function prev() {
			setCurrentPage((currentPage) => Math.max(currentPage - 1, 1));
		}

		function jump(page) {
			const pageNumber = Math.max(1, page);
			setCurrentPage((currentPage) => Math.min(pageNumber, maxPage));
		}

		return { next, prev, jump, currentData, currentPage, maxPage };
	}

	// Fução para alterar a página no pagination do mobile
	const handleChangePage = (e, p) => {
		setPage(p);
		_DATA.jump(p);
	};

	return (
		<Box sx={styles.boxDataGrid}>
			{windowWidth <= 760 ? (
				// Exibição Mobile
				<Box>
					<Divider />
					{Array.isArray(filteredRows) &&
						_DATA.currentData().map((row, index) => (
							<Box key={index}>
								<ListItem sx={styles.mobile.listItem}>
									<Box sx={styles.mobile.content}>
										<Box sx={styles.mobile.contentRow}>
											<Box>
												<Typography
													sx={styles.mobile.typography}
													variant="caption"
												>
													Hora:{" "}
												</Typography>
												<Typography variant="caption">
													{dayjs(row?.createAt)
														.tz(timeZone)
														.format("DD/MM/YYYY HH:mm:ss")}
												</Typography>
											</Box>
											<Box>
												<Typography
													sx={styles.mobile.typography}
													variant="caption"
												>
													Usuário:{" "}
												</Typography>
												<Typography variant="caption">
													{row?.user?.nome + " " + row?.user?.sobrenome}
												</Typography>
											</Box>
										</Box>
										<Box sx={styles.mobile.contentRow}>
											<Box>
												<Typography
													sx={styles.mobile.typography}
													variant="caption"
												>
													Recurso:{" "}
												</Typography>
												<Typography variant="caption">{row?.table}</Typography>
											</Box>
											<Box>
												<Typography
													sx={styles.mobile.typography}
													variant="caption"
												>
													Tipo:{" "}
												</Typography>
												<Chip
													label={row?.status === 0 ? "Falha" : "Sucesso"}
													sx={{
														bgcolor:
															row?.status === 0
																? "chip.main.pending"
																: "chip.main.completed",
														width: "100px",
														color: theme.palette.colors.white.lighter,
														fontWeight: 600,
													}}
													size="small"
												/>
											</Box>
										</Box>
									</Box>
									<IconButton
										onClick={(event) => {
											event.preventDefault();
											//setAnchorEl(event.currentTarget);
											setSelectedRow(row);
											setOpenDetalhes(!openDetalhes);
										}}
										id="basic-button"
									>
										<OpenInNew mode="view" />
									</IconButton>
								</ListItem>
								<Divider />
							</Box>
						))}
					<Box sx={{ display: "flex", marginTop: "10px" }}>
						<Stack sx={{ margin: "auto" }} spacing={2}>
							<Pagination
								count={count}
								page={page}
								onChange={handleChangePage}
							/>
						</Stack>
					</Box>
				</Box>
			) : (
				// Exibição Desk
				<Box
					sx={{
						display: "flex",
						width: "100%",
						...(filteredRows?.length > 23 && {
							height: "calc(100vh - 174px)",
						}),
						overflow: "hidden",
					}}
				>
					<DatagridComponent
						loading={initialLoad}
						rows={filteredRows}
						columns={columns}
						isPagination={true}
					/>
				</Box>
			)}
			<ModalDetails
				openDetalhes={openDetalhes}
				setOpenDetalhes={setOpenDetalhes}
				selectedRow={selectedRow}
			/>
		</Box>
	);
}
